import { styled } from 'baseui'

export const Title = styled('h2', ({ $theme }) => ({
  margin: 0,
  fontSize: '1.125rem',
  color: $theme.colors.textHeading,
}))

export const MutedText = styled('p', ({ $theme }) => ({
  margin: '0.25rem 0 0',
  fontSize: '0.875rem',
  color: $theme.colors.textMuted,
}))

export const Table = styled('table', {
  width: '100%',
  borderCollapse: 'collapse',
  marginTop: '0.75rem',
})

export const Th = styled('th', ({ $theme }) => ({
  textAlign: 'left',
  padding: '0.5rem',
  fontSize: '0.8125rem',
  color: $theme.colors.textMuted,
  borderBottom: `0.0625rem solid ${$theme.colors.borderLight}`,
}))

export const Td = styled('td', ({ $theme }) => ({
  padding: '0.5rem',
  fontSize: '0.875rem',
  borderBottom: `0.0625rem solid ${$theme.colors.borderLight}`,
}))

export const SearchRow = styled('div', {
  display: 'flex',
  alignItems: 'center',
  gap: '0.75rem',
  marginTop: '1rem',
  maxWidth: '40rem',
})
